import React, { useState, useEffect } from "react";
import axios from "axios";
import ProgressLoader from "../Loader/ProgressLoader";
import "./ProfilePage.css";
import Preheader from "../KalHome/Preheader";
import Prefooterads from "../Homecomponents/Prefooterads";
import Newsletter from "../Homecomponents/Newsletter";
import Footer from "../Homecomponents/Footer";
import SocialLinks from "../Homecomponents/Sociallinks";
import Endfooter from "../Homecomponents/Endfooter";
import Header from "../KalHome/Header";
import Headerads from "../KalHome/Headerads";
import Superheader from "../KalHome/Superheader";

const ProfilePage = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    mobile: "",
    fullAddress: "",
    landmark: "",
    pincode: ""
  });
  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: ""
  });
  const [userId, setUserId] = useState("");
  const [message, setMessage] = useState({ type: "", text: "" });
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(()=>{
    if (message.text) {
      const timer = setTimeout(() => {
        setMessage({ type: "", text: "" });
      }, 1500);
      return () => clearTimeout(timer);
    }
  },[message])

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true);
        const user = JSON.parse(sessionStorage.getItem("user"));
        if (!user || !user.email) {
          setMessage({ type: "error", text: "User not logged in" });
          setLoading(false);
          return;
        }

        const response = await axios.get(
          "https://api.dremerz.net/api/Kalanjiyam_Users_Registration"
        );
        const users = response.data;
        const currentUser = users.find(us => us.email === user.email);
        
        if (!currentUser) {
          setMessage({ type: "error", text: "User not found" });
          setLoading(false);
          return;
        }
        
        setUserId(currentUser.id);
        setUserData(currentUser);
        setFormData({
          fullname: currentUser.fullname || "",
          email: currentUser.email || "",
          mobile: currentUser.mobile || "",
          fullAddress: currentUser.fullAddress || "",
          landmark: currentUser.landmark || "",
          pincode: currentUser.pincode || ""
        });
        
        setLoading(false);
      } catch (error) {
        console.error("Error fetching user data:", error);
        setMessage({ type: "error", text: "Failed to fetch user data" });
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    
    try {
      setLoading(true);
      await axios.put(
        `https://api.dremerz.net/api/Kalanjiyam_Users_Registration/${userId}`,
        { 
          fullname: formData.fullname,
          fullAddress: formData.fullAddress,
          landmark: formData.landmark,
          pincode: formData.pincode
        }
      );

      setTimeout(() => {
        setUserData(prev => ({ ...prev, ...formData }));
        setMessage({ type: "success", text: "Profile updated successfully" });
        setEditMode(false);
        setLoading(false);
      }, 1000);
    } catch (error) {
      console.error("Error updating profile:", error);
      setMessage({ type: "error", text: "Failed to update profile" });
      setLoading(false);
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      setMessage({ type: "error", text: "New passwords do not match" });
      return;
    }

    try {
      setLoading(true);
      // In a real application, you would verify the current password first
      // For this example, we'll assume the API handles password verification
      await axios.put(
        `https://api.dremerz.net/api/Kalanjiyam_Users_Registration/${userId}`,
        { 
          password: passwordData.newPassword
        }
      );

      setTimeout(() => {
        setMessage({ type: "success", text: "Password updated successfully" });
        setShowPasswordModal(false);
        setPasswordData({
          currentPassword: "",
          newPassword: "",
          confirmPassword: ""
        });
        setLoading(false);
      }, 1000);
    } catch (error) {
      console.error("Error updating password:", error);
      setMessage({ type: "error", text: "Failed to update password" });
      setLoading(false);
    }
  };

  if (loading && !userData) {
    return (
      <div className="profile-loading-container">
        <ProgressLoader />
      </div>
    );
  }

  return (
    <>
      {/* <Preheader /> */}
      <Superheader />
      <div className={isSticky ? "header-wrapper sticky" : "header-wrapper"}>
        <Header />
      </div>

      <div className="user-profile-container">
        <div className="container py-4">
          <div className="row justify-content-center">
            <div className="col-12 col-md-10 col-lg-8">
              <div className="profile-card card">
                <div className="card-header">
                  <div className="profile-header-content">
                    <div className="profile-avatar m-0 me-4">
                      <i className="fas fa-user-circle"></i>
                    </div>
                    <h2 className="profile-title m-0">User Profile</h2>
                  </div>
                </div>
                
                <div className="card-body">
                  {!userData ? (
                    <div className="text-center py-4">
                      <p>No user data available. Please log in again.</p>
                    </div>
                  ) : (
                    <>
                      {editMode ? (
                        <form onSubmit={handleProfileSubmit} className="profile-form">
                          <div className="row">
                            <div className="col-12 col-md-6 mb-3">
                              <div className="form-floating">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="fullname"
                                  name="fullname"
                                  value={formData.fullname}
                                  onChange={handleInputChange}
                                  required
                                  placeholder="Full Name"
                                />
                                <label htmlFor="fullname">Full Name</label>
                              </div>
                            </div>
                            <div className="col-12 col-md-6 mb-3">
                              <div className="form-floating">
                                <input
                                  type="email"
                                  className="form-control"
                                  id="email"
                                  name="email"
                                  value={formData.email}
                                  onChange={handleInputChange}
                                  required
                                  disabled
                                  placeholder="Email"
                                />
                                <label htmlFor="email">Email</label>
                              </div>
                            </div>
                          </div>
                          
                          <div className="row">
                            <div className="col-12 col-md-6 mb-3">
                              <div className="form-floating">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="mobile"
                                  name="mobile"
                                  value={formData.mobile}
                                  onChange={handleInputChange}
                                  required
                                  disabled
                                  placeholder="Mobile"
                                />
                                <label htmlFor="mobile">Mobile</label>
                              </div>
                            </div>
                          </div>
                          
                          <div className="row">
                            <div className="col-12 mb-3">
                              <div className="form-floating">
                                <textarea
                                  className="form-control"
                                  id="fullAddress"
                                  name="fullAddress"
                                  value={formData.fullAddress}
                                  onChange={handleInputChange}
                                  rows="3"
                                  placeholder="Full Address"
                                  style={{ height: "100px" }}
                                />
                                <label htmlFor="fullAddress">Full Address</label>
                              </div>
                            </div>
                          </div>
                          
                          <div className="row">
                            <div className="col-12 col-md-6 mb-3">
                              <div className="form-floating">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="landmark"
                                  name="landmark"
                                  value={formData.landmark}
                                  onChange={handleInputChange}
                                  placeholder="Landmark"
                                />
                                <label htmlFor="landmark">Landmark</label>
                              </div>
                            </div>
                            <div className="col-12 col-md-6 mb-3">
                              <div className="form-floating">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="pincode"
                                  name="pincode"
                                  value={formData.pincode}
                                  onChange={handleInputChange}
                                  placeholder="Pincode"
                                />
                                <label htmlFor="pincode">Pincode</label>
                              </div>
                            </div>
                          </div>
                          
                          <div className="d-flex gap-2 mt-4 flex-wrap">
                            <button 
                              type="submit" 
                              className="btn btn-save"
                              disabled={loading}
                              style={{background:"#920504", color:"white"}}
                            >
                              {loading ? (
                                <>
                                  <span className=" me-2" role="status" aria-hidden="true"></span>
                                  Saving...
                                </>
                              ) : (
                                <>
                                  <i className="fas fa-save me-2"></i>
                                  Save Changes
                                </>
                              )}
                            </button>
                            <button 
                              type="button" 
                              className="btn btn-outline-secondary"
                              onClick={() => {
                                setEditMode(false);
                                setFormData({
                                  fullname: userData.fullname,
                                  email: userData.email,
                                  mobile: userData.mobile,
                                  fullAddress: userData.fullAddress || "",
                                  landmark: userData.landmark || "",
                                  pincode: userData.pincode || ""
                                });
                              }}
                            >
                              <i className="fas fa-times me-2"></i>
                              Cancel
                            </button>
                          </div>
                        </form>
                      ) : (
                        <>
                          <div className="profile-info">
                            <div className="info-group">
                              <div className="info-item">
                                <div className="info-label">
                                  <i className="fas fa-user me-2"></i>
                                  Full Name:
                                </div>
                                <div className="info-value">{userData.fullname || "Not provided"}</div>
                              </div>
                              <div className="info-item">
                                <div className="info-label">
                                  <i className="fas fa-envelope me-2"></i>
                                  Email:
                                </div>
                                <div className="info-value">{userData.email || "Not provided"}</div>
                              </div>
                              <div className="info-item">
                                <div className="info-label">
                                  <i className="fas fa-mobile-alt me-2"></i>
                                  Mobile:
                                </div>
                                <div className="info-value">{userData.mobile || "Not provided"}</div>
                              </div>
                              <div className="info-item">
                                <div className="info-label">
                                  <i className="fas fa-map-marker-alt me-2"></i>
                                  Full Address:
                                </div>
                                <div className="info-value">{userData.fullAddress || "Not provided"}</div>
                              </div>
                              <div className="info-item">
                                <div className="info-label">
                                  <i className="fas fa-map-pin me-2"></i>
                                  Landmark:
                                </div>
                                <div className="info-value">{userData.landmark || "Not provided"}</div>
                              </div>
                              <div className="info-item">
                                <div className="info-label">
                                  <i className="fas fa-mail-bulk me-2"></i>
                                  Pincode:
                                </div>
                                <div className="info-value">{userData.pincode || "Not provided"}</div>
                              </div>
                            </div>
                          </div>
                          
                          <div className="mt-4 d-flex gap-2 flex-wrap">
                            <button 
                              className="btn btn-edit"
                              onClick={() => setEditMode(true)}
                              style={{background:"#920504", color:"white"}}
                            >
                              <i className="fas fa-edit me-2"></i>
                              Edit Profile
                            </button>
                            <button 
                              className="btn btn-outline-secondary"
                              onClick={() => setShowPasswordModal(true)}
                            >
                              <i className="fas fa-key me-2"></i>
                              Change Password
                            </button>
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Password Change Modal */}
      {showPasswordModal && (
        <div className="home-modal-overlay">
          <div className="home-modal-content">
            <h3>Change Password</h3>
            <form onSubmit={handlePasswordSubmit}>
              <div className="mb-3">
                <div className="form-floating">
                  <input
                    type="password"
                    className="form-control"
                    id="currentPassword"
                    name="currentPassword"
                    value={passwordData.currentPassword}
                    onChange={handlePasswordChange}
                    required
                    placeholder="Current Password"
                  />
                  <label htmlFor="currentPassword">Current Password</label>
                </div>
              </div>
              <div className="mb-3">
                <div className="form-floating">
                  <input
                    type="password"
                    className="form-control"
                    id="newPassword"
                    name="newPassword"
                    value={passwordData.newPassword}
                    onChange={handlePasswordChange}
                    required
                    placeholder="New Password"
                  />
                  <label htmlFor="newPassword">New Password</label>
                </div>
              </div>
              <div className="mb-3">
                <div className="form-floating">
                  <input
                    type="password"
                    className="form-control"
                    id="confirmPassword"
                    name="confirmPassword"
                    value={passwordData.confirmPassword}
                    onChange={handlePasswordChange}
                    required
                    placeholder="Confirm New Password"
                  />
                  <label htmlFor="confirmPassword">Confirm New Password</label>
                </div>
              </div>
              <div className="home-modal-actions">
                <button 
                  type="button" 
                  className="btn-cancel btn-md" 
                  onClick={() => {
                    setShowPasswordModal(false);
                    setPasswordData({
                      currentPassword: "",
                      newPassword: "",
                      confirmPassword: ""
                    });
                  }}
                >
                  Cancel
                </button>
                <button 
                  type="submit" 
                  className="btn-login btn-md"
                  disabled={loading}
                >
                  {loading ? "Updating..." : "Update"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
                      {message.text && (
        <div className="home-modal-overlay">
          <div className="home-modal-content">
            <h3>{message.type}</h3>
            <p>{message.text}</p>
            <div className="home-modal-actions">
              <button
                className="btn-cancel"
                onClick={() => setMessage({ type: "", text: "" })}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
                )}


      <Footer />
      <Endfooter />
    </>
  );
};

export default ProfilePage;